export function CheckIcon({ className }: { className?: string }) {
  return (
    <svg className={className} width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.3572 4.1437L1.36637 2.92317C1.08355 2.57385 0.590083 2.53807 0.266307 2.84321C-0.0574691 3.14834 -0.0906264 3.68074 0.19219 4.03007L1.18302 5.2506C1.56921 5.72829 2.129 5.99976 2.71608 5.99976C3.33438 5.99976 3.91171 5.70304 4.29986 5.18326L6.82661 1.36965C7.09772 1.0077 7.04506 0.477398 6.70958 0.186995C6.3741 -0.105512 5.88258 -0.048694 5.61342 0.313257L3.08667 4.12687C2.90918 4.36256 2.54249 4.37097 2.3572 4.1416V4.1437Z" fill="currentColor"/>
    </svg>
  );
}
